import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['userConfig', 'useDarkMode'])
  },
  watch: {
    useDarkMode() {
      this.setSiteIcon();
    }
  },
  methods: {
    setSiteIcon() {
      // 同时更改 icon apple-touch-icon 和 mask-icon
      const existingIcons = document.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"], link[rel="mask-icon"]');
      existingIcons.forEach(icon => icon.remove());
      const iconLink = document.createElement('link');
      const appleIconLink = document.createElement('link');
      const maskIconLink = document.createElement('link');
      iconLink.rel = 'icon';
      appleIconLink.rel = 'apple-touch-icon';
      maskIconLink.rel = 'mask-icon';
      if (this.useDarkMode) {
        iconLink.href = this.userConfig?.siteIcon || '/logo-dark.png';
        appleIconLink.href = this.userConfig?.siteIcon || '/logo-dark.png';
        maskIconLink.href = this.userConfig?.siteIcon || '/logo-dark.png';
      } else {
        iconLink.href = this.userConfig?.siteIcon || '/logo.png';
        appleIconLink.href = this.userConfig?.siteIcon || '/logo.png';
        maskIconLink.href = this.userConfig?.siteIcon || '/logo.png';
      }
      document.head.appendChild(iconLink);
      document.head.appendChild(appleIconLink);
      document.head.appendChild(maskIconLink);
    }
  }
};